import Layout from '@layouts/Layout';
import Demo from '@screens/Demo';

import React, { memo } from 'react';

const title = 'Get a FREE Demo';
const description = 'Get the demo version of our Traqq app and experience seamless time tracking and remote employee management. Zero commitments or obligations!';

const DemoPage = () => (
    <Layout
        title={ title }
        description={ description }
    >
        <Demo />
    </Layout>
);

export default memo(DemoPage);
